import React from "react";
import Layout from "../Layout/Layout";
const SnappTicket = () => {
  return <Layout></Layout>;
};

export default SnappTicket;
